import axios from "axios";
import * as Constants from "../constant";

const uploadMedia = async (formData) => {
	try {
		const response = await axios.post(
			`${Constants?.LOCAL_URL}/asset/uploadImage`,
			formData
		);
		return response;
	} catch (error) {
		return error;
	}
};
export default uploadMedia;
